<template>
    <div class="form_item">
        <p class="title" :class="itemData.required ? 'required' : ''">
            <span class="serial">{{ itemData.index }}</span>
            <span>{{ itemData.title }}</span>
            <span v-show="itemData.pass === false" class="pass_tag">{{ itemData.errMsg }}</span>
        </p>
        <!-- 文本框 -->
        <!-- <el-input v-if="textType.includes(itemData.type)" v-model="answer" @blur="onValidateFormat(itemData.type)" /> -->
        <el-input v-if="textType.includes(itemData.type)" v-model="answer" />
        <!-- 单选框 -->
        <el-radio-group v-else-if="itemData.type === 'radio'" class="radio_group" v-model="answer">
            <el-radio v-for="(item, index) in itemData.options" :key="index" class="radio_item" :label="item.id">
                {{ item.text }}
            </el-radio>
        </el-radio-group>
        <!-- 复选框 -->
        <el-checkbox-group v-else-if="itemData.type === 'checkbox'" class="checkbox_group" v-model="answer">
            <template v-for="(item, index) in itemData.options">
                <el-checkbox :key="index" class="checkbox_item" :label="item.id">{{ item.text }}</el-checkbox>
            </template>
        </el-checkbox-group>
        <!-- 上传文件 -->
        <el-upload v-else-if="['image', 'video'].includes(itemData.type)" class="upload-demo"
            action="https://comback0303.com/index/respondent/upload" :limit="itemData.type === 'image' ? 5 : 1"
            :file-list="fileList" :before-upload="onValidateFile" :on-success="onUploadSuccess"
            :before-remove="onRemoveFile">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">最多上传{{ itemData.type === 'image' ? '5张图片' : '1个视频' }}</div>
        </el-upload>
    </div>
</template>
<script>
export default {
    name: 'FormItem',
    props: {
        itemData: {
            type: Object,
            default: function () {
                return {
                    index: 0,
                    title: '表单标题',
                    required: 1,
                    pass: false,
                    errMsg: '',
                    type: 'memberid',
                    options: []
                }
            },
        },
        value: {
            type: [String, Array]
        },
    },
    emits: ['input', 'validateFormat', 'getUploadState'],
    data() {
        return {
            answer: '', // 答案
            fileList: [], // 文件列表
            textType: ['content', 'phone', 'memberid', 'membername', 'email', 'qq', 'weixin'], // 文本框表单类型
            pass: null, // 答案是否合规
            errMsg: '', // 错误提示
        };
    },
    computed: {},
    watch: {
        value: {
            handler: function (newVal) {
                this.$set(this, 'answer', newVal)
            },
            immediate: true
        },
        answer: function (newVal) {
            this.$emit('input', newVal)
        }
    },
    created() { },
    mounted() { },
    methods: {
        // 表单格式校验
        // onValidateFormat(type) {
        //     let pass
        //     switch (type) {
        //         case 'phone':
        //             const phoneRegex = /^1[34578]\d{9}$/
        //             pass = phoneRegex.test(this.answer)
        //             break
        //         case 'email':
        //             const emailRegex = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,5}$/
        //             pass = emailRegex.test(this.answer)
        //             break
        //         case 'qq':
        //             const qqRegex = /^[1-9][0-9]{4,14}$/
        //             pass = qqRegex.test(this.answer)
        //             break
        //         case 'weixin':
        //             const weixinRegex = /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/
        //             pass = weixinRegex.test(this.answer)
        //             break
        //         default:
        //             pass = true
        //     }

        //     const passInfo = {
        //         pass,
        //         errMsg: pass ? '验证通过' : '格式错误'
        //     }
        //     this.$emit('validateFormat', passInfo)
        // },
        // 上传前 文件校验
        onValidateFile(file) {
            const { type } = this.itemData
            const pass = file.type.includes(type)
            if (pass) this.$emit('getUploadState', true)
            return pass
        },
        // 文件上传成功的回调
        onUploadSuccess(res) {
            this.$emit('getUploadState', false)
            if (!res.code) return
            const { filename: name, path } = res?.data || {}
            this.fileList.push({ name, path })
            this.answer.push(path)
        },
        // 移除上传文件的回调
        onRemoveFile(file) {
            const index = this.fileList.findIndex(item => item.name == file.name)
            if (index === -1) return
            this.fileList.splice(index, 1)
            this.answer.splice(index, 1)
        },
    }
}
</script>
<style lang="scss">
.form_item {
    margin-bottom: 20px;

    .title {
        margin-bottom: 10px;
        position: relative;

        &.required::before {
            content: '*';
            color: red;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(calc(-100% - 4px), -50%);
        }

        .serial {
            margin-right: 4px;
        }

        .pass_tag {
            display: inline-block;
            vertical-align: 2px;
            font-size: 14px;
            color: #fff;
            background: #da2319;
            padding: 2px 7px;
            border-radius: 6px;
            margin-left: 10px;
        }
    }

    .radio_group,
    .checkbox_group {
        display: flex;
        flex-direction: column;

        .radio_item,
        .checkbox_item {
            height: 40px;
            padding: 0 8px;
            border-radius: 4px;
            margin: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            &:hover {
                background-color: rgba(35, 120, 255, 0.1);
            }
        }
    }
}
</style>